module.exports = __webpack_public_path__ + "static/media/advantageIcon.6ce8e554.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/advantageIcon.png
// module id = 903
// module chunks = 0